class HomeSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: 6000,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.slide',
            arrowShape: 'M84.333,47.697c0,-26.258 -21.287,-47.546 -47.546,-47.546l-36.454,0l0,95.096l36.454,-0c26.259,-0.001 47.546,-21.288 47.546,-47.547l0,-0.003Zm-26.08,-2.008l-0,4.02l-24.143,0l11.066,11.067l-2.843,2.842l-15.919,-15.919l15.919,-15.919l2.843,2.842l-11.066,11.067l24.143,-0Z'
            //arrowShape: 'M8.644,41.375l-0.015,-0.014l-8.629,8.629l0.014,0.014l-0.005,0.006l8.629,8.629l0.006,-0.005l41.216,41.216l8.629,-8.629l-35.156,-35.156l76.667,-0l0,-12.204l-76.584,0l35.082,-35.082l-8.629,-8.629l-41.225,41.225Z'
        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default HomeSlider;
